import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  authGroupsKeys,
  RequestTypes,
} from '@core/react-query/features/authGroups'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUpdateAuthGroup = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['updateAuthGroup']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...authGroupsKeys.updateAuthGroup,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: authGroupsKeys._def })
    },
    ...options,
  })
}
